// Retrieve token in localStorage
export const retrieveToken = (): string => {
  const tokenStorage = window.localStorage.getItem('okta-token-storage');
  if (tokenStorage) {
    return `Bearer ${JSON.parse(tokenStorage).idToken.idToken}`;
  }
  return '';
};
